import { NormalIconProps } from 'assets/icons';
import React from 'react';

export const EditIcon: React.FC<NormalIconProps> = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="51" height="50" fill="none" className={props.className || ''}>
		<g filter="url(#a)">
			<rect width="18" height="18" x="16.5" y="8" fill="#fff" rx="9" shapeRendering="crispEdges" />
			<path
				stroke="#004D43"
				strokeWidth=".625"
				d="m26.483 13.7.387-.387a1.638 1.638 0 1 1 2.317 2.317l-.386.387M26.483 13.7s.049.82.773 1.544c.724.724 1.545.773 1.545.773M26.483 13.7l-3.55 3.55c-.24.24-.36.36-.464.493a2.738 2.738 0 0 0-.312.505 5.7 5.7 0 0 0-.234.636l-.455 1.367m7.333-4.234-3.55 3.55c-.241.24-.362.36-.494.464a2.727 2.727 0 0 1-.505.312c-.152.073-.313.126-.636.234l-1.367.456m0 0-.334.111a.442.442 0 0 1-.559-.559l.111-.334m.782.782-.781-.782"
			/>
		</g>
		<defs>
			<filter id="a" width="50" height="50" x=".5" y="0" colorInterpolationFilters="sRGB" filterUnits="userSpaceOnUse">
				<feFlood floodOpacity="0" result="BackgroundImageFix" />
				<feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
				<feMorphology in="SourceAlpha" radius="4" result="effect1_dropShadow_800_3517" />
				<feOffset dy="8" />
				<feGaussianBlur stdDeviation="10" />
				<feComposite in2="hardAlpha" operator="out" />
				<feColorMatrix values="0 0 0 0 0.0588235 0 0 0 0 0.0901961 0 0 0 0 0.164706 0 0 0 0.12 0" />
				<feBlend in2="BackgroundImageFix" result="effect1_dropShadow_800_3517" />
				<feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
				<feMorphology in="SourceAlpha" radius="3" result="effect2_dropShadow_800_3517" />
				<feOffset dy="3" />
				<feGaussianBlur stdDeviation="3" />
				<feComposite in2="hardAlpha" operator="out" />
				<feColorMatrix values="0 0 0 0 0.0588235 0 0 0 0 0.0901961 0 0 0 0 0.164706 0 0 0 0.08 0" />
				<feBlend in2="effect1_dropShadow_800_3517" result="effect2_dropShadow_800_3517" />
				<feBlend in="SourceGraphic" in2="effect2_dropShadow_800_3517" result="shape" />
			</filter>
		</defs>
	</svg>
);
